import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col text-brown" }
const _hoisted_2 = { class: "text-2xl font-semibold mb-4" }
const _hoisted_3 = { class: "font-bold text-base leading-[20px] mb-4" }
const _hoisted_4 = { class: "font-normal text-base leading-[20px] mb-4" }
const _hoisted_5 = { class: "mb-10 font-normal text-base leading-[20px] list-none" }
const _hoisted_6 = { class: "font-bold" }

import { useI18n } from "vue-i18n";

import { ICzinResponse } from "@/types/calculators";
import ResultStack from "@/views/Calculators/ICzinPrediction/components/ResultStack.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PredictionResult',
  props: {
    results: {},
    prediction: {}
  },
  emits: ["reset"],
  setup(__props: any) {

const { t } = useI18n();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResultStack, {
      results: __props.results,
      class: "mb-10"
    }, null, 8, ["results"]),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.prediction.hexagram), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.prediction.image), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.prediction.main_text), 1),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.prediction.details, (val, key) => {
        return (_openBlock(), _createElementBlock("li", { key: key }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("calculators.iczin.hexagram." + key)) + ":", 1),
          _createTextVNode(" " + _toDisplayString(val), 1)
        ]))
      }), 128))
    ]),
    _createVNode(GradientButton, {
      class: "mx-auto w-[223px] min-h-14",
      "bg-color": "bg-brown-gradient",
      "hover-bg-color": "bg-orange-gradient",
      text: _unref(t)('calculators.iczin.repeat-prediction-btn'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
    }, null, 8, ["text"])
  ]))
}
}

})